<template>
    <BreadCrumb PageTitle="Modifier un contact" />
    <EditContact />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditContact from "../../components/ContactSMS/EditContact.vue";
  
    export default defineComponent({
      name: "EditContactPage",
      components: {
        BreadCrumb,
        EditContact,
      },
    });
  </script>